// formatTimeAgo — "X minutes ago" | "X hours ago" | "Yesterday" | "D MMM YYYY".
// Used by the admin activity feed (dashboard card + full ActivityPage).
export function formatTimeAgo(iso: string): string {
  const date = new Date(iso);
  const now = new Date();
  const diffMinutes = Math.max(0, Math.floor((now.getTime() - date.getTime()) / 60_000));
  const diffHours = Math.floor(diffMinutes / 60);

  if (diffMinutes < 60) {
    return diffMinutes <= 0 ? "Just now" : `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;
  }
  if (diffHours < 24) {
    return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
  }

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday =
    date.getFullYear() === yesterday.getFullYear() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getDate() === yesterday.getDate();
  if (isYesterday) return "Yesterday";

  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}
